import { createStore } from "vuex";
import device from "./modules/device";
import menu from "./modules/menu";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    device,
    menu,
  },
});
